import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  CircularProgress,
} from '@mui/material';
import {
  CheckCircle,
  Schedule,
  ArrowForward,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const SuccessScreen = ({ paymentType, amount, netAmount }) => {
  const navigate = useNavigate();

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-AE', {
      style: 'currency',
      currency: 'AED',
      minimumFractionDigits: 2
    }).format(value);
  };

  const isGatewayPayment = paymentType === 'GATEWAY';

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', mt: 4 }}>
      <Card>
        <CardContent sx={{ textAlign: 'center', py: 6 }}>
          {isGatewayPayment ? (
            <CheckCircle sx={{ fontSize: 80, color: 'success.main', mb: 2 }} />
          ) : (
            <Schedule sx={{ fontSize: 80, color: 'warning.main', mb: 2 }} />
          )}

          <Typography variant="h4" gutterBottom fontWeight={600}>
            {isGatewayPayment ? 'Payment Successful!' : 'Request Submitted!'}
          </Typography>

          {isGatewayPayment ? (
            <>
              <Typography variant="body1" color="text.secondary" paragraph sx={{ mt: 2 }}>
                Your wallet has been topped up with
              </Typography>
              <Typography variant="h5" color="success.main" fontWeight={700} gutterBottom>
                {formatCurrency(netAmount)}
              </Typography>
              <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1 }}>
                (After gateway fees)
              </Typography>
            </>
          ) : (
            <>
              <Typography variant="body1" color="text.secondary" paragraph sx={{ mt: 2 }}>
                Your topup request for
              </Typography>
              <Typography variant="h5" color="primary.main" fontWeight={700} gutterBottom>
                {formatCurrency(parseFloat(amount))}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                has been received and is pending approval.
              </Typography>

              <Box
                sx={{
                  mt: 3,
                  p: 2,
                  bgcolor: 'warning.50',
                  borderRadius: 2,
                  border: 1,
                  borderColor: 'warning.200'
                }}
              >
                <Typography variant="body2" color="text.secondary">
                  <strong>What happens next?</strong>
                </Typography>
                <Box component="ul" sx={{ textAlign: 'left', mt: 1, pl: 2 }}>
                  <li>
                    <Typography variant="body2">
                      Our finance team will review your request
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="body2">
                      Processing time: 1-2 business days
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="body2">
                      You'll receive an email notification when approved
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="body2">
                      Amount will be added to your wallet automatically
                    </Typography>
                  </li>
                </Box>
              </Box>
            </>
          )}

          <Box sx={{ mt: 4, display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Button
              variant="contained"
              size="large"
              endIcon={<ArrowForward />}
              onClick={() => navigate('/account/wallet')}
            >
              Go to My Wallet
            </Button>

            {!isGatewayPayment && (
              <Button
                variant="outlined"
                size="large"
                onClick={() => navigate('/account/wallet')}
              >
                View My Requests
              </Button>
            )}
          </Box>

          <Box sx={{ mt: 3 }}>
            <Typography variant="caption" color="text.secondary">
              {isGatewayPayment ? 'Redirecting to your wallet...' : 'You can close this page now'}
            </Typography>
            {isGatewayPayment && (
              <Box sx={{ mt: 2 }}>
                <CircularProgress size={24} />
              </Box>
            )}
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default SuccessScreen;
